var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPolls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.89,44.26H4.74c-1.06,0-1.93-.86-1.93-1.93V5.67c0-1.06,.86-1.93,1.93-1.93H12.89c1.06,0,1.93,.86,1.93,1.93V42.33c0,1.06-.86,1.93-1.93,1.93Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.88,44.26h-8.15c-1.06,0-1.93-.86-1.93-1.93V21.08c0-1.06,.86-1.93,1.93-1.93h8.15c1.06,0,1.93,.86,1.93,1.93v21.26c0,1.06-.86,1.93-1.93,1.93Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.26,44.26h-8.15c-1.06,0-1.93-.86-1.93-1.93V11.44c0-1.06,.86-1.93,1.93-1.93h8.15c1.06,0,1.93,.86,1.93,1.93v30.89c0,1.06-.86,1.93-1.93,1.93Z",
    fill: filledColor
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.89,44.26H4.74c-1.06,0-1.93-.86-1.93-1.93V5.67c0-1.06,.86-1.93,1.93-1.93H12.89c1.06,0,1.93,.86,1.93,1.93V42.33c0,1.06-.86,1.93-1.93,1.93Zm-6.22-3.85h4.29V7.59H6.66V40.41Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.88,44.26h-8.15c-1.06,0-1.93-.86-1.93-1.93V21.08c0-1.06,.86-1.93,1.93-1.93h8.15c1.06,0,1.93,.86,1.93,1.93v21.26c0,1.06-.86,1.93-1.93,1.93Zm-6.22-3.85h4.29V23h-4.29v17.41Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.26,44.26h-8.15c-1.06,0-1.93-.86-1.93-1.93V11.44c0-1.06,.86-1.93,1.93-1.93h8.15c1.06,0,1.93,.86,1.93,1.93v30.89c0,1.06-.86,1.93-1.93,1.93Zm-6.22-3.85h4.29V13.37h-4.29v27.04Z",
    fill: outlineColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPolls);
export default __webpack_public_path__ + "static/media/ico-polls.beca96491ccc7fef3307b97f54ebc9bd.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;